export function getRem(value) {
  return typeof value === 'number' ? "".concat(value / 10, "rem") : value;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9nZXRSZW0udHMiXSwibmFtZXMiOlsiZ2V0UmVtIiwidmFsdWUiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sU0FBU0EsTUFBVCxDQUFnQkMsS0FBaEIsRUFBeUM7QUFDOUMsU0FBTyxPQUFPQSxLQUFQLEtBQWlCLFFBQWpCLGFBQStCQSxLQUFLLEdBQUcsRUFBdkMsV0FBaURBLEtBQXhEO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gZ2V0UmVtKHZhbHVlPzogbnVtYmVyIHwgc3RyaW5nKSB7XG4gIHJldHVybiB0eXBlb2YgdmFsdWUgPT09ICdudW1iZXInID8gYCR7dmFsdWUgLyAxMH1yZW1gIDogdmFsdWU7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/getRem.js
// module id = 492
// module chunks = 118